import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';

import withScrollWatcher from 'apps/fops/containers/withScrollWatcher';

import { ensureProducts } from 'apps/products/actions/products';
import { setMainFopCollectionMaxDisplayFops } from 'apps/catalogue/actions/catalogue';

import SubscriptionsFopListContainer from '../components/SubscriptionsFopListContainer';

export default withScrollWatcher(ensureProducts)(
  connect(
    (state, ownProps) => ({
      errorMessage: state.subscriptions.errorMessage,
      fopCollection: get(state, `catalogue.productsPagesByRoute['${ownProps.routeString}'].mainFopCollection`),
      productsBySku: state.products.productsBySku,
      subscriptionsBySku: state.subscriptions.subscriptionsBySku,
      fopViewPreference: state.user.viewTypePreference,
      betaFeatures: state.user.betaFeatures,
    }),
    (dispatch) => ({
      dispatch,
      ...bindActionCreators({ setMainFopCollectionMaxDisplayFops }, dispatch),
    })
  )(SubscriptionsFopListContainer)
);
